import { Shape } from "@mui/system"

export const shape: Shape = {
    borderRadius: 12
}